"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const modal_1 = require("components/cosmos/v2/modal");
const icons_1 = __importDefault(require("components/icons"));
const translate_1 = require("components/translate");
const useShellContext_1 = require("hooks/useShellContext");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const trackCta_svg_url_1 = __importDefault(require("./trackCta.svg?url"));
const trackUtils_1 = __importDefault(require("./trackUtils"));
const getStorageKey = (userId) => {
    const STORAGE_KEY = 'track-cta-modal:visualized';
    return `${STORAGE_KEY}:user=${userId}`;
};
const markCtaAsVisualized = (storageKey) => {
    localStorage.setItem(storageKey, 'true');
};
const shouldShowCtaModal = (storageKey) => {
    const isCtaModalVisualized = localStorage.getItem(storageKey);
    if (isCtaModalVisualized === 'true') {
        return false;
    }
    markCtaAsVisualized(storageKey);
    return true;
};
const TrackCtaModal = ({ t, userId, productId, shortLocale }) => {
    const storageKey = getStorageKey(userId);
    const { isMembership } = (0, useShellContext_1.useShellContext)();
    const [show, setShowModal] = (0, react_1.useState)(() => {
        if (isMembership) {
            return false;
        }
        return shouldShowCtaModal(storageKey);
    });
    const handleCloseModal = () => {
        setShowModal(false);
    };
    const redirectToMembership = async () => {
        if (productId) {
            const membershipURL = await trackUtils_1.default.getAccessHotmartClubUrl(productId);
            window.location.href = membershipURL;
        }
    };
    return ((0, jsx_runtime_1.jsxs)(modal_1.Modal, { show: show, onClose: handleCloseModal, children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)("p", { className: "_my-0 _text-4 _text-gray-700 _font-weight-bold", children: t('tracks.cta_modal.title') }) }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { children: [(0, jsx_runtime_1.jsx)("img", { src: trackCta_svg_url_1.default, className: "_w-full _h-auto _mb-6" }), (0, jsx_runtime_1.jsx)("p", { className: "_mt-0 _mb-3 _text-gray-700 _font-weight-bold", children: t('general.learning_tracks') }), (0, jsx_runtime_1.jsx)("p", { className: "_my-0 _text-gray-500", children: t('tracks.cta_modal.description') })] }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: "_d-flex _align-items-center _justify-content-end _flex-column _flex-md-row", children: [(0, jsx_runtime_1.jsxs)("a", { target: "_blank", rel: "noreferrer", href: trackUtils_1.default.getLearningTrackArticleUrl(shortLocale), className: "hot-button hot-button--secondary _text-decoration-none _d-flex _align-items-center _mb-4 _mb-md-0", children: [(0, jsx_runtime_1.jsx)("span", { className: "_mr-4", children: t('tracks.cta_buttons.know_more') }), (0, jsx_runtime_1.jsx)(icons_1.default, { prefix: "fal", iconName: "arrow-up-right-from-square" })] }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", onClick: redirectToMembership, children: t('tracks.cta_buttons.access_hotmart_club') })] })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    userId: stores.UserStore.marketplaceId,
    shortLocale: stores.UserStore.shortLocale,
    productId: stores.MembershipStore.productId
})))(TrackCtaModal);
